import React, { useState, useEffect } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Link,
  List,
  Divider,
  ListItem,
  ListItemButton,
  Box,
  Alert,
  CircularProgress,
  Button,
} from "@mui/material";
import Login from "../components/login.component";
import { useStateContext } from "../context/ContextProvider";
import axiosClientSevan from "../axiosClientSevan";
import moment from 'moment';

export default function LoginScreen() {
  const { setToken, setUser, setStore } = useStateContext();
  const [showSelection, setShowSelection] = useState(false);
  const [customerCompanies, setCustomerCompanies] = useState([]);
  const [customerToken, setCustomerToken] = useState();
  const [stores, setStores] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    var urlParams = new URLSearchParams(window.location.search);
    var token = urlParams.get("token");
    var store = urlParams.get("store");
    if (token && store) {
      setToken(token);
      setStore(store);
    }
  }, []);

  const setTokenAndUser = (store) => {
    setLoading(true);
    const sevanPayload = {
      shop_code: JSON.parse(store).store_bill_id,
      service_id: 301,
      platform_name: "SOFTECH",
    };

    axiosClientSevan
      .post("api/shop/service/exist", sevanPayload)
      .then((response) => {
        const serviceWithExpDates = response.data.data.service_type_data;
        const hasAServiceActive = serviceWithExpDates.filter(
          (obj) => obj.service_type_expriration_Date != "-"
        );

        const currentDate = moment().format('DD-MM-YYYY');
        let expirationDate = hasAServiceActive[0].service_type_expriration_Date;
        const momentDate1 = moment(currentDate, 'DD-MM-YYYY');
        const momentDate2 = moment(expirationDate, 'DD-MM-YYYY');

        if (momentDate1.isAfter(momentDate2)) {
          setLoading(false);
          console.log(currentDate)
          console.log(expirationDate)
          setErrorMessage("No active subscription!");
        } else {
          setLoading(false);
          setToken(customerToken);
          setUser(customerCompanies);
          setStore(store);
        }
      });
  };

  if (showSelection && stores.length >= 1) {
    return (
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: "100vh" }}
      >
        <Grid item xs={12} sm={8} md={6}>
          <Card style={{ maxWidth: 400 }}>
            <CardContent>
              <Typography
                variant="h6"
                component="h2"
                align="center"
                gutterBottom
              >
                Select store
              </Typography>
              {errorMessage && (
                <Alert severity="error" sx={{ marginBottom: 1 }}>
                  {errorMessage}
                </Alert>
              )}
              {errorMessage && (
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => {
                    window.open(process.env.REACT_APP_SEVAN_BASE_URL, "_blank");
                  }}
                >
                  Renew here!
                </Button>
              )}
              <Divider sx={{ height: "16px" }} />
              {customerCompanies.Companies.map((company) => (
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: 360,
                    bgcolor: "white",
                  }}
                >
                  <List>
                    {company.Stores.map((store) => (
                      <>
                        <ListItem disablePadding>
                          <ListItemButton
                            onClick={() =>
                              setTokenAndUser(JSON.stringify(store))
                            }
                          >
                            <Typography variant="button">
                              {store.name}
                            </Typography>
                          </ListItemButton>
                        </ListItem>
                        <Divider sx={{ height: "8px" }} />
                      </>
                    ))}
                  </List>
                </Box>
              ))}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: "100vh" }}
    >
      <Grid item xs={12} sm={8} md={6}>
        <Card style={{ maxWidth: 400 }}>
          <CardContent>
            <Typography variant="h5" component="h2" align="center" gutterBottom>
              Login
            </Typography>
            {loading && (
              <Box display="flex" justifyContent="center" alignItems="center">
                <CircularProgress />
              </Box>
            )}
            <Login
              setShowSelection={setShowSelection}
              setCustomerCompanies={setCustomerCompanies}
              setCustomerToken={setCustomerToken}
              setStores={setStores}
              setLoading={setLoading}
            />
            <Typography
              variant="body2"
              color="textSecondary"
              align="center"
              mt={2}
            >
              Don't have an account? <Link href="/register">Register now!</Link>
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              align="center"
              mt={2}
            >
              Forgot your password?{" "}
              <Link href={`${process.env.REACT_APP_SEVAN_BASE_URL}password/reset`}>
                Reset it here!
              </Link>
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
